import React, { useEffect, forwardRef } from 'react'
import { XDivider, FlexByRow } from 'irmlib/styles'
import styled from 'styled-components'
import { useMergeState } from '../../../../irmlib/src/hooks'
import { useHistory } from 'react-router-dom'
import { ContainedButton, OutlinedButton } from 'irmlib/components/Controls'
import * as routePaths from '../../../../navigation/routePaths'
import * as gdeTransactions from '../../../../services/firestore/gdeTransactions'
import * as gdeTransactionsLite from '../../../../services/firestore/gdeTransactionsLite'
import { clearBusy, closeGeneralDialog, openGeneralDialog, setBusy } from '../../../../irmlib/src/containers'
import { userRoleAdmin, userRoleSuperUser, userRoleSupervisor, userRoleUser } from '../../../../common/constants'
import UserRolePermission from '../../../Controls/UserRolePermission'
import * as constants from 'irmlib/common/constants'
import { errorToast, successToast } from '../../../../common/functions'
import { getFunctions, httpsCallable } from '../../../../utils/firestore'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

const functions = getFunctions()

const ButtonsContainer = styled(FlexByRow)`
  justify-content: flex-end;
  padding-top: 1%;
`

const initialState = {
  readyToTransmitCheck: false,
  transmitButton: false,
  jobsforTransmission: [],
  allJobsforTransmission: ''
}

const TopButtons = forwardRef((props, ref) => {
  const [, setState, getState] = useMergeState(initialState)
  const [disabledAssign, setdisabledAssign] = React.useState(true)
  const [disabledEdit, setdisabledEdit] = React.useState(true)
  const [disabledUpload, setDisabledUpload] = React.useState(true)
  const [disabledTransmit, setdisabledTransmit] = React.useState(true)
  // const [disabledReTransmit, setdisabledReTransmit] = React.useState(true)
  const [allowManualTransmit, setAllowManualTransmit] = React.useState('')
  const [allowEditJob, setAllowEditJob] = React.useState('')
  
  // eslint-disable-next-line no-unused-vars
  // const [transmit, settransmit] = React.useState(true)
  // const [JobState, setJobState] = React.useState(true)
  // const [reTransmitJobId, setReTransmitJobId] = React.useState(false)
  const history = useHistory()
  const { t } = useTranslation()
  const selectedRows = props.selectedData
  useEffect(() => {
    const additionalGivenPermissions = window?.sessionStorage?.getItem('additional-permissions-user')
    if (additionalGivenPermissions !== 'undefined' && additionalGivenPermissions !== undefined) {
      const additionalPermissionsForUser = JSON.parse(additionalGivenPermissions)
      const indexOfManuallTransmitJob = additionalPermissionsForUser?.map(object => object?.value)?.indexOf('manuallyTransmitJob')
      const indexOfEditJob = additionalPermissionsForUser?.map(object => object?.value)?.indexOf('editJob')
  
      if (additionalPermissionsForUser[indexOfManuallTransmitJob]?.enabled) {
        setAllowManualTransmit(userRoleUser)
      }
      if (additionalPermissionsForUser[indexOfEditJob]?.enabled) {
        setAllowEditJob(userRoleSupervisor)
      }                              
    }
  }, [])

  useEffect(() => {
    setdisabledTransmit(true)
    // when there is only one job selected for transmission
    if (selectedRows?.length === 1) {
      if (isEmpty(selectedRows[0])) {
        onSelectionChange(selectedRows[0])
      } else {
        setdisabledAssign(true)
        setdisabledEdit(true)
        setdisabledTransmit(true)
        setDisabledUpload(true)
      }
    } else if (selectedRows?.length > 1) {
      setdisabledAssign(true)
      setdisabledEdit(true)
      setDisabledUpload(true)
      // when there are multiple jobs selected for transmission
      onSelectMultiple(selectedRows)
    } else {
      setdisabledAssign(true)
      setdisabledEdit(true)
      setdisabledTransmit(true)
      setDisabledUpload(true)
    }
  }, [props.selectedData])

  const isEmpty = (obj) => {
    return Object.values(obj).length
  }
  
  const onSelectionChange = async (rows) => {
    const rawJobByIdData = await gdeTransactions.getJobById(rows?.jobId)
    const jobData = rawJobByIdData.data()
    if (rows?.status1 === constants.jobStatus.pending || rows?.status1 === constants.jobStatus.assigned) {
      setdisabledEdit(false)
      setdisabledAssign(false)
    }
    if (rows?.status1 === constants.jobStatus.inProgress) {
      setdisabledEdit(false)
    }
    if (jobData?.isUploadCustomerDataFile === true && rows?.status1 === constants.jobStatus.assigned) {
      setDisabledUpload(false)
    }
    // this code is written for retransmission
    // if (rows?.status1 === constants.jobStatus.transmitted) {
    //   setdisabledReTransmit(false)
    // }
    // below if added to disable assign job button
    if (rows?.status1 === constants.jobStatus.cancel || 
        rows?.status1 === constants.jobStatus.transmitted || 
        rows?.status1 === constants.jobStatus.readyToTransmit) {
      setdisabledAssign(true)
      setdisabledEdit(true)
    }
    
    if (rows?.status1 === constants.jobStatus.inProgress) {
      setdisabledAssign(true)
    }
    // const rawJobByIdData = await gdeTrancactions.getJobById(rows?.jobId)
    // const jobData = rawJobByIdData.data()
    if (rows?.status1 === constants.jobStatus.readyToTransmit && rows?.autoTransmit === 'false') {
      const collection = await gdeTransactionsLite.getBoxesForJob(rows?.jobId)
      const boxList = []
      const boxUserList = []
    
      collection.forEach((doc) => {
        const data = doc.data()
        boxList.push({
          boxId: data.boxId,
          entryUser: data.dataEntryUser,
          status: data.status,
          dataEntryUser: data.dataEntryUser,
          verificationUser: data.verificationUser
        })
        boxUserList.push(doc.data().dataEntryUser)
      })
      const checkReadyToTransmit = (Boxes) => {
        return Boxes.status === constants.boxStatus.approved || Boxes.status === constants.boxStatus.exception
      }
      const result = boxList.filter(checkReadyToTransmit)
      const transmitBoxEqual = boxList.length === 0 ? false : rows?.boxes === result.length
      if (transmitBoxEqual === true) {
        setdisabledTransmit(false)
        setState({ jobsforTransmission: rows })
      }
    } else {
      setdisabledTransmit(true)
    }
  }

  const onSelectMultiple = async (rows) => {
    // We are verifying that the selected jobs are in the Manual transmit and Ready to transmit status.
    for (let i = 0; i < selectedRows?.length; i++) {
      if (rows[i]?.status1 === constants.jobStatus.readyToTransmit && rows[i]?.autoTransmit === 'false') {
        setState({ readyToTransmitCheck: true })
      } else {
        setState({ readyToTransmitCheck: false })
        break
      }
    }
    if (getState().readyToTransmitCheck) {
      if (rows?.length > 10) {
        const ten = 10
        errorToast({ message: t('messages.AlertText', { count: ten }), title: t('messages.attention'), isBlocking: true, closeIcon: true })
      } else {
        setBusy()
        let multiplejobs = ''
        // Checking that all of the selected jobs have the necessary box count for transmission.
        for (let i = 0; i < rows?.length; i++) {
          const collection = await gdeTransactionsLite.getBoxesForJob(rows[i]?.jobId)
          const boxList = []
          const boxUserList = []
      
          collection.forEach((doc) => {
            const data = doc.data()
            boxList.push({
              boxId: data.boxId,
              entryUser: data.dataEntryUser,
              status: data.status,
              dataEntryUser: data.dataEntryUser,
              verificationUser: data.verificationUser
            })
            boxUserList.push(doc.data().dataEntryUser)
          })
          const checkReadyToTransmit = (Boxes) => {
            return Boxes.status === constants.boxStatus.approved || Boxes.status === constants.boxStatus.exception
          }
          const result = boxList.filter(checkReadyToTransmit)
          const transmitBoxEqual = boxList.length === 0 ? false : rows[i]?.boxes === result.length
          // setting a state variable to verify if all the boxCounts of the selected jobs are accurate for transmission
          if (transmitBoxEqual) {
            setState({ transmitButton: true })
            multiplejobs += `${rows[i].jobId}, `
            // Storing the job Ids in a string for displaying in the message
            setState({ allJobsforTransmission: multiplejobs })
          } else {
            // if any of the boxCounts of the selected jobs are not accurate for transmission
            setState({ transmitButton: false })
            break
          }
        }
        clearBusy()
        // enabling and disabling of the transmit button on the basis of the Transmit button state variable
        if (getState().transmitButton) {
          // storing the jobs if All the conditions for transmission are passed 
          setState({ jobsforTransmission: rows })
          setdisabledTransmit(false)
        } else {
          setdisabledTransmit(true)
        }
      }
    } else {
      setdisabledTransmit(true)
    }
  }
    
  const ButtonsForTransmitDialogBox = () =>
    <>
      <OutlinedButton onClick={closeGeneralDialog} >buttons.no</OutlinedButton>
      <ContainedButton onClick={handleTransmitButtonOnClick} >buttons.yes</ContainedButton>
    </>
  
  const handleTransmitButtonOnClick = () => {
    // when there multiple jobs for transmission
    if (selectedRows?.length > 1) {
      setdisabledTransmit(true)
      for (let i = 0; i < getState().jobsforTransmission?.length; i++) {
        const callabletransmit = httpsCallable(functions, 'grpGde-ManuallyExportSkpApprovedAssets')
        callabletransmit({ jobId: getState().jobsforTransmission[i].jobId }).then((result) => {
          successToast({ message: t('toast.transmitQueued', { jobId: getState().allJobsforTransmission }) })
        }).catch(error => {
          errorToast({ message: error = t('toast.manualTransmitFailMessage'), title: t('toast.manualTransmitFailTitle') })
          clearBusy()
        })
      }
      closeGeneralDialog()
    } else {
      // when only one job is selected for transmission
      setdisabledTransmit(true)
      const callabletransmit = httpsCallable(functions, 'grpGde-ManuallyExportSkpApprovedAssets')
      callabletransmit({ jobId: selectedRows[0].jobId }).then((result) => {
        successToast({ message: t('toast.transmitQueued', { jobId: selectedRows[0].jobId }) })
      }).catch(error => {
        errorToast({ message: error = t('toast.manualTransmitFailMessage'), title: t('toast.manualTransmitFailTitle') })
        clearBusy()
      })
      closeGeneralDialog()
    }
    // for unchecking the selected job or jobs for transmisson
    history.push(`${routePaths.AllOpenJobs}`)
  }
  
  // const ButtonsForRetransmitDialogBox = () =>
  //   <>
  //     <OutlinedButton onClick={closeGeneralDialog} >buttons.no</OutlinedButton>
  //     <ContainedButton onClick={handleRetransmitButtonOnClick} >buttons.yes</ContainedButton>
  //   </>
    
  // const handleRetransmitButtonOnClick = async () => {
  //   const data = {
  //     actionTs: new Date(),
  //     boxesCompleted: 0,
  //     jobLevelRetransmit: true,
  //     jobStatus: constants.jobStatus.readyToTransmit,
  //     autoTransmit: 'true',
  //     autoTransmitAndStatus: `true-${constants.jobStatus.readyToTransmit}`,
  //   }
  //   await gdeTrancactions.updateJob(selectedRows[0].jobId, data)
  
  //   const boxesRaw = await gdeTrancactions.getBoxesForJob(selectedRows[0].jobId)
  //   boxesRaw.forEach(async(ele) => {
  //     const box = ele.data()
  //     await gdeTrancactions.updateBoxData(selectedRows[0].jobId, box.boxId, 
  //       { 
  //         actionTs: new Date(), 
  //         status: constants.boxStatus.approved,
  //         transmissionStatus: constants.boxTransmissionStatus.pending,
  //         transmissionStatusTs: new Date(), 
  //       })
  //   })
  
  //   setdisabledReTransmit(true)
  //   successToast({ message: t('toast.reTransmitQueued', { jobId: selectedRows[0].jobId }) })
  //   closeGeneralDialog()
  // }
  
  const handleTransmit = () => {
    // when there are multiple jobs selected for transmission
    if (getState().jobsforTransmission?.length > 1) {
      openGeneralDialog({
        title: t('messages.multipleTransmit'),
        message: t('messages.multipleTransmitConfirmMessage', { jobList: getState().allJobsforTransmission }),
        translateMessage: false,
        noTranslateTitle: true,
        buttons: <ButtonsForTransmitDialogBox />,
        closeX: true
      })
    } else {
      // when only one job is selected for transmission
      openGeneralDialog({
        title: t('messages.transmit'),
        noTranslateTitle: true,
        message: t('messages.transmitConfirmMessage'),
        translateMessage: false,
        buttons: <ButtonsForTransmitDialogBox />,
        closeX: true
      })
    }
  }
  
  // const handleReTransmit = () => {
  //   openGeneralDialog({
  //     title: t('messages.reTransmit'),
  //     noTranslateTitle: true,
  //     message: t('messages.reTransmitConfirmMessage'),
  //     translateMessage: false,
  //     buttons: <ButtonsForRetransmitDialogBox />,
  //     closeX: true
  //   })
  // }
  
  return (
    <ButtonsContainer>
  
      <UserRolePermission allowsTo={[userRoleAdmin, userRoleSuperUser]}>
        <OutlinedButton id={'allJobs_createJob'} size='small' variant='contained' onClick={() => history.push(routePaths.createJob)}>
          demo.createNewJobs
        </OutlinedButton>
        <XDivider width='18px' />
      </UserRolePermission>
  
      <OutlinedButton id={'allJobs_assignJobs'} disabled={disabledAssign} size='small' onClick={() => history.push(`${routePaths.assignJob}/${selectedRows[0].jobId}/FromAllJobs`)}>
        demo.AssignJobs
      </OutlinedButton>
  
      <XDivider width='18px' />
  
      <UserRolePermission allowsTo={[userRoleAdmin, allowEditJob, userRoleSuperUser]}>
        <OutlinedButton id={'allJobs_editJobs'} disabled={disabledEdit} size='small' onClick={() => history.push(`${routePaths.editJob}/${selectedRows[0].jobId}`)}>
          demo.editJob
        </OutlinedButton>
        <XDivider width='18px' />
      </UserRolePermission>
  
      <UserRolePermission allowsTo={[userRoleAdmin, userRoleSupervisor, userRoleSuperUser]}>
        <OutlinedButton id={'allJobs_editJobs'} disabled={disabledUpload} size='small' onClick={() => history.push(`${routePaths.UploadCustomerData}/${selectedRows[0].jobId}/FromAllJobs`)}>
          demo.uploadDataForJob
        </OutlinedButton>
        <XDivider width='18px' />
      </UserRolePermission>
  
      <UserRolePermission allowsTo={[userRoleAdmin, allowManualTransmit, userRoleSuperUser]}>
        <OutlinedButton disabled={disabledTransmit} id={'allJobs_editJobs'} size='small' onClick={handleTransmit}>
          demo.Transmit
        </OutlinedButton>
        <XDivider width='18px' />
      </UserRolePermission>
  
      {/* <UserRolePermission allowsTo={[userRoleAdmin]}>
        <OutlinedButton disabled={disabledReTransmit} id={'allJobs_editJobs'} size='small' onClick={handleReTransmit}>
          demo.reTransmit
        </OutlinedButton>
        <XDivider width='18px' />
      </UserRolePermission> */}
    </ButtonsContainer>
  )
})

TopButtons.propTypes = {
  selectedData: PropTypes.object,
}

export default TopButtons
